import React, { Component } from 'react';
import * as THREE from 'three';
import React3 from 'react-three-renderer';
import _ from 'lodash';
import Toolbar from "./Toolbar";
import Timeline from "./Timeline";

var STLLoader = require('three-stl-loader')(THREE);
//var DRACOLoader = require('../../DRACOLoader');
// require('../../geometry_helper');

var OrbitControls = require('three-orbit-controls')(THREE);
var TWEEN = require("@tweenjs/tween.js");

class Viewport extends Component{
    constructor(props, context) {
        super(props, context);

        this.cameraPosition = new THREE.Vector3(0, 0, 300);
        this.lightLooksAt = new THREE.Vector3(0, 0, 0);
        this.lightPosition = new THREE.Vector3(-30, 10, 100);
        this.viewportWidth = document.getElementsByClassName("mainview").innerWidth;
        this.viewportHeight = document.getElementsByClassName("mainview").innerHeight;

        this.manager = new THREE.LoadingManager();
        this.loader = new STLLoader();
        // Global Draco decoder type.
        // var dracoDecoderType = {};
        // dracoDecoderType.type = 'js';
        // this.loader = new THREE.DRACOLoader('../../', dracoDecoderType);

        this.state = {
            viewportWidth: 0,
            viewportHeight: 0,
            activePart: 'both',
            activeModel: 0,
            activeView: 'front',
            errors: []
        };

        this._onAnimate = () => {
            TWEEN.update();
            this.resizeCanvasToDisplaySize();
        };
    }
    // shouldComponentUpdate(){
    //     return false;
    // }
    componentDidMount(){
        var that = this;
        this.setState(
            {
                viewportWidth: this.refs.mainviewport.getBoundingClientRect().width,
                viewportHeight: document.querySelector('main.main').clientHeight-165
                - document.querySelector('.app-footer').clientHeight
            }
        )
        const controls = new OrbitControls(this.refs.camera, this.refs.sceneContainer);
        this.controls = controls;
        this.controls.enablePan = true;


        if(!_.isEmpty(this.props.modelsObj)){
            // var models = this.props.models.sort();
            var models = _.sortBy(this.props.modelsObj, 'order')
            models = _.map(models, 'url');

            var modelsPaired = _.chunk(models, 2);
            modelsPaired.forEach(function (model, index) {
                that.loadModel('/modelos/' + model[0], index + "_0", index);
                that.loadModel('/modelos/' + model[1], index + "_1", index);
            });
        }
    }
    componentDidUpdate(nextProps, nextState){
        var that = this;
        if(this.props.modelsObj !== nextProps.modelsObj){
            // var models = this.props.models.sort();
            var models = _.sortBy(this.props.modelsObj, 'order')
            models = _.map(models, 'url');

            var modelsPaired = _.chunk(models, 2);
            modelsPaired.forEach(function (model, index) {
                that.loadModel('/modelos/' + model[0], index + "_0", index);
                that.loadModel('/modelos/' + model[1], index + "_1", index);
            });
        }

        if(this.refs.models.children.length <= 0){
            return false;
        }
        if(!_.isEmpty(nextProps.models)){
            var models = nextProps.models.sort();
            var modelsPaired = _.chunk(models, 2);
            modelsPaired.forEach((model, index) => {
                this.refs.models.getObjectByName("object_" + index + "_0").visible = false;
                this.refs.models.getObjectByName("object_" + index + "_1").visible = false;
            });
            this.refs.models.getObjectByName("object_" + this.state.activeModel + "_0").visible = true;
            this.refs.models.getObjectByName("object_" + this.state.activeModel + "_1").visible = true;
        }
        switch(this.state.activePart){
            case 'top':
                this.refs.models.getObjectByName("object_" + this.state.activeModel + "_0").visible = false;
                this.refs.models.getObjectByName("object_" + this.state.activeModel + "_1").visible = true;
                break;
            case 'bottom':
                this.refs.models.getObjectByName("object_" + this.state.activeModel + "_0").visible = true;
                this.refs.models.getObjectByName("object_" + this.state.activeModel + "_1").visible = false;
                break;
            default:
                this.refs.models.getObjectByName("object_" + this.state.activeModel + "_0").visible = true;
                this.refs.models.getObjectByName("object_" + this.state.activeModel + "_1").visible = true;
        }
    }
    componentWillUnmount() {
        this.controls.dispose();
        delete this.controls;
        this.refs.models.remove();
    }

    resizeCanvasToDisplaySize(force) {
        const canvas = this.refs.renderer._canvas;
        const width = canvas.parentElement.parentElement.parentElement.clientWidth;
        const height = canvas.parentElement.parentElement.parentElement.clientWidth;
        if (canvas.width !== width) {
            this.setState({viewportWidth: width});
            this.refs.camera.aspect = width / height;
            this.refs.camera.updateProjectionMatrix();
        }
    }
    loadModel(model, name, index){
        var that = this;
        this.manager.onStart = function( item, loaded, total ) {
            // that.props.startLoading();
            var loader = document.createElement('div');
            var loadingContainer = document.createElement('div');
            var loadingContent = document.createElement('div');
            var progress = document.createElement('div');
            var progressBar = document.createElement('div');

            var textLoader = document.createElement('span');

            progress.className = "progress";
            progress.style.height = "3px";
            progressBar.className = "progress-bar loader-viewer";
            progress.appendChild(progressBar);

            loadingContainer.className = "loadingContainer";
            loadingContent.className = "loadingContent";
            textLoader.textContent = "Cargando modelos";
            textLoader.className = "loaderText";
            loadingContent.appendChild(textLoader);
            loadingContent.appendChild(progress);
            loadingContainer.appendChild(loadingContent);
            loader.appendChild(loadingContainer);
            loader.id = "loading";
            loader.style.background = "rgba(230,240,181,0.9)";
            // loader.style.background = "rgba(0,0,0,0.7)";
            loader.style.zIndex= 1200;
            loader.style.position = "absolute";
            loader.style.display = "block"
            loader.style.top = 0;
            loader.style.left = 0;
            loader.style.width = "100%";
            loader.style.height = "100%";
            document.querySelector(".sub-main").appendChild(loader);

        };

        this.manager.onLoad = function() {
            //that.props.endLoading();
            document.querySelector(".sub-main").removeChild(document.getElementById("loading"));
        };
        this.manager.onProgress = function( item, loaded, total ) {
            document.querySelector(".loader-viewer").style.width = (loaded/total)*100 + "%";
        };
        this.manager.onError = function( url ) {
            that.setState({errors: [...that.state.errors, url]})
        };

        this.loader.manager = this.manager;
        this.loader.load(model, function(geometry) {
            geometry.computeVertexNormals();
            var material = new THREE.MeshPhongMaterial({color: 0xd4ab74});
            var mesh = new THREE.Mesh(geometry, material);

            mesh.name = "object_" + name;
            if (index > 0) {
                mesh.visible = false;
            }

            mesh.position.set(0, 0, 0.2);
            mesh.rotation.set(0, 0, 0);
            mesh.scale.set(0.06, 0.06, 0.06);

            mesh.castShadow = true;
            mesh.receiveShadow = true;
            that.refs.models.add(mesh);
        });
    }
    hideParts(object){
        this.setState({
            activePart: object
        });
    }
    activateModel(id){
        this.setState({
            activeModel: id
        });
        this.props.changeStep(id);
    }
    resetView(){
        this.hideParts('both')
        this.setState({activeView: 'front'});
        this.changeView({x: 0, y: 0, z: 300});
        this.controls.reset();
    }
    viewLeft(){
        this.hideParts('both')
        this.setState({activeView: 'left'})
        this.changeView({x: 300, y: 0, z: 0})
    }
    viewRight(){
        this.hideParts('both')
        this.setState({activeView: 'right'})
        this.changeView({x: -300, y: 0, z: 0})
    }
    viewTop(){
        this.hideParts('top')
        this.setState({activeView: 'top'})
        this.changeView({x: 0, y: -270, z: 0})
    }
    viewBottom(){
        this.hideParts('bottom')
        this.setState({activeView: 'bottom'})
        this.changeView({x: 0, y: 270, z: 0})
    }
    changeView(axis) {
        let self = this;

        function goAxis(axis){
            new TWEEN.Tween( self.refs.camera.position )
                .to( axis, 600 )
                .easing( TWEEN.Easing.Cubic.Out)
                .onUpdate(function () {
                    self.refs.camera.lookAt(self.refs.models.position)
                })
                .start();
        }
        // reset to original position
        new TWEEN.Tween( this.refs.camera.position )
            .to( {x: 0, y: 0, z: 300}, 200 )
            .easing( TWEEN.Easing.Cubic.Out)
            .onUpdate(function () {
                self.refs.camera.lookAt(self.refs.models.position)
            })
            .onComplete(function(){
                goAxis(axis);
                self.controls.reset();
            })
            .start();

    }
    renderErrors(){
        return this.state.errors.map(item => {
            return <li key={item}><b>{item}</b></li>
        });
    }
    render() {
        const width = this.state.viewportWidth; // canvas width
        const height = this.state.viewportHeight; // canvas height

        return (
            <div style={{
                position:'relative',
                marginLeft: '-40px',
                marginRight: '-40px',
                marginBottom: '-40px'
            }} ref="mainviewport">
                {this.state.errors.length > 0 ? <div className="alert alert-danger mt-4">Ha ocurrido un error subiendo los modelos listados a continuación. Para solucionarlo vaya a la pestaña modelos, bórrelos y subalos de nuevo:<ol>{this.renderErrors()}</ol></div> :
                <Toolbar
                    hideParts={this.hideParts.bind(this)}
                    viewLeft={this.viewLeft.bind(this)}
                    viewRight={this.viewRight.bind(this)}
                    viewTop={this.viewTop.bind(this)}
                    viewBottom={this.viewBottom.bind(this)}
                    resetView={this.resetView.bind(this)}
                />
                }
                <div ref="sceneContainer" className="viewer-content">
                    <React3
                        ref="renderer"
                        mainCamera="camera"
                        width={width}
                        height={height}
                        antialias={true}
                        onAnimate={this._onAnimate}
                        alpha={true}
                    >
                        <scene>
                            <perspectiveCamera
                                name="camera"
                                ref="camera"
                                fov={1}
                                aspect={width / height}
                                near={0.1}
                                far={1000}
                                position={this.cameraPosition}
                            >
                                <spotLight
                                    intensity={0.8}
                                    position={this.lightPosition}
                                    lookAt={this.lightLooksAt}
                                />
                            </perspectiveCamera>
                            <group
                                name="models"
                                ref="models"
                            />
                            <ambientLight
                                intensity={0.2}
                            />
                        </scene>
                    </React3>
                </div>
                <Timeline
                    models={this.props.models}
                    timelineLength={this.props.models}
                    activateModel={this.activateModel.bind(this)}
                />
            </div>);
    }
}
export default Viewport;


// WEBPACK FOOTER //
// ./resources/assets/js/components/viewer/Viewport.jsx